import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

import { ScoringComponent } from '../scoring/scoring.component';
 

@Component({
  selector: 'app-multiply-calc',
  template: `
    <p>
      {{numb1}} * {{numb2}} = 
      <input id="myRes" #box matInput type="number"  
        (keyup.enter)="update(box.value)" 
        (blur)="update(box.value)" 
        [(ngModel)]="inputValue">
    </p>
    <div [ngSwitch]="resState">
      <div *ngSwitchCase="'correct'">
        <p>Rigtigt</p>
      </div>
      <div *ngSwitchCase="'incorrect'">
        <p>Forkert - det rigtige result er {{result}}.</p>
        <button (click)="nextStep()">Fortsæt</button>
      </div>
    </div>
  `,
  styles: []
})
export class MultiplyCalcComponent extends ScoringComponent {
  @Input() level: number;

  inputValue:number = null;
  
  numb1: number;
  numb2: number;
  min1: number;
  min2: number;
  result: number;
  resState = 'calculating'
  calcLevel: number;
  
  constructor() { super(); }

  ngOnInit() {
    this.start();  
  }

  clearValue(){ 
    this.inputValue = null;
  }

  start() {
    this.calcLevel = this.level;
    this.initLevel(this.calcLevel);
    this.newCalc();
    this.reset();
  }

  newCalc(){
    this.resState = 'calculating' 
    this.numb1 = this.newValue(this.numb1,this.min1);
    this.numb2 = this.newValue(this.numb2,this.min2);
    this.result = this.numb1 * this.numb2;
    this.startTime(); 
    document.getElementById('myRes').focus();
    //document.getElementById('myRes').value = '';
    this.clearValue();
  }

  newValue(old: number, min: number): number {
    var newVal = old; 
    while (old == newVal)
    {
      newVal = Math.floor(Math.random() * 9)+min;
    }
    return newVal;
  }

  initLevel(val: number){
    if (val == 0)
    {
      this.min1 = 1;
      this.min2 = 1;
      this.setTimeBonus(0.000333);
    }
    else if (val == 1)
    {
      this.min1 = 1;
      this.min2 = 11;
      this.setTimeBonus(0.001);
    }
    else
    {
      this.min1 = 11;
      this.min2 = 11;
      this.setTimeBonus(0.003);
    }
  }

  checkResult(value: number){
    if (value == this.result){
      this.resState = 'correct';  
      this.correct();
      
      setTimeout(()=>{this.nextStep();},1000);  
    } 
    else {
      this.resState = 'incorrect';    
      this.wrong();
    }
  }

  nextStep(){
    if(this.done())
    {
      this.givePoints();
    }
    else
    {
      this.newCalc();
    }
  }


  update(value: number) {
    if (value)
      this.checkResult(value);
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/multiply/multiply-calc.component.ts